import MeetingManagerPage from "@Evaluation/Estimations/Pages/MeetingManagerPage.vue";
import PanelistAlternativePage from "@Evaluation/Estimations/Pages/PanelistAlternativePage.vue";
import PanelistDashboardPage from "@Evaluation/Estimations/Pages/PanelistDashboardPage.vue";
import PanelistMeetingPage from "@Evaluation/Estimations/Pages/PanelistMeetingPage.vue";
import PanelistsPage from "@Evaluation/Estimations/Pages/PanelistsPage.vue";
import PanelsPage from "@Evaluation/Estimations/Pages/PanelsPage.vue";



export const routes = [
    {
        path: "/pp/assessments/:workspaceId/:projectId",
        component: PanelsPage,
    },
    {
        path: "/pp/assessments-panelists/:workspaceId/:projectId/:surveyId",
        component: PanelistsPage,
    },
    {
        path: "/pp/assessments-review/:workspaceId/:projectId/:surveyId",
        component: MeetingManagerPage,
    },
    {
        path: "/est/dashboard/:workspaceId/:surveyId/:projectUserId",
        component: PanelistDashboardPage,
    },
    {
        path: "/est/alternative/:workspaceId/:surveyId/:projectUserId/:alternativeId",
        component: PanelistAlternativePage,
    },
    {
        path: "/est/meeting/:workspaceId/:surveyId/:projectUserId",
        component: PanelistMeetingPage,
    },
]
